///<reference path="../event/EventDispatcher.ts"/>
///<reference path="../event/Event.ts"/>

namespace com.enirva.net
{
	import EventDispatcher = com.enirva.event.EventDispatcher;
	import Event = com.enirva.event.Event;
	
	export class URLLoader extends EventDispatcher
	{
		public data:any;
		
		constructor()
		{
			super();
		}
		
		
		public load(request:URLRequest):void
		{
			var scope:URLLoader = this;
			
			$(function():void
			{
				$.ajax({
					url:request.url,
					type:"GET",
					dataType:"html",
					timeout:2000,
					error:function():void
					{
						console.log("load error");
					},
					success:function(text:any):void
					{
						scope.data = text;
						
						var evt:Event = new Event(Event.COMPLETE);
						scope.dispatchEvent(evt);
					}
				})
			});
		}
	}
}

